// extracted by mini-css-extract-plugin
export default {"title":"ModalChangePassword_title__p7cPl","formChangePass":"ModalChangePassword_formChangePass__NrReT"};